export default "__VITE_ASSET__C71S6l5i__"